export default __webpack_public_path__ + "static/media/emotionDecH.a7e45da0.png";